var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveLater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3558 18.8633H16.3949C10.9086 18.8633 6.41699 23.3549 6.41699 28.8412V65.2879C6.41699 69.94 9.75365 71.9291 13.8282 69.6512L26.437 62.6249C27.7845 61.887 29.9662 61.887 31.2816 62.6249L43.8903 69.6512C47.9649 71.9291 51.3015 69.94 51.3015 65.2879V28.8412C51.3336 23.3549 46.842 18.8633 41.3558 18.8633Z",
    stroke: "#121212",
    strokeWidth: 4.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5837 16.3958V52.8426C70.5837 57.4946 67.247 59.4517 63.1724 57.2058L51.3337 50.5967V28.8442C51.3337 23.3579 46.842 18.8663 41.3558 18.8663H25.667V16.3958C25.667 10.9096 30.1586 6.41797 35.6449 6.41797H60.6058C66.092 6.41797 70.5837 10.9096 70.5837 16.3958Z",
    fill: "#0D44AD",
    stroke: "#0D44AD",
    strokeWidth: 4.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3337 28.8412V65.2879C51.3337 69.9399 47.997 71.897 43.9224 69.6512L31.3137 62.6249C29.9662 61.887 27.7845 61.887 26.437 62.6249L13.8282 69.6512C9.75365 71.897 6.41699 69.9399 6.41699 65.2879V28.8412C6.41699 23.3549 10.9086 18.8633 16.3949 18.8633H41.3558C46.842 18.8633 51.3337 23.3549 51.3337 28.8412Z",
    fill: "#E5EBF9",
    stroke: "white",
    strokeWidth: 4.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveLater);
export default __webpack_public_path__ + "static/media/saveLater.097214efe3bd3800805b4cbe95523389.svg";
export { ForwardRef as ReactComponent };